import { Injectable } from '@angular/core';
import { TypeForRateType } from "@afidium/ts-facade/model/typeForRateType";
import { DifferenceType } from "@afidium/ts-facade/model/differenceType";
import { IDifference } from "libraries/interfaces/fare-optimisation/IFareOptimisation";
import { RateInDifferenceType } from "@afidium/ts-facade";
import { TypeForRateInDifferenceType } from "@afidium/ts-facade/model/typeForRateInDifferenceType";

@Injectable({
    providedIn: 'root'
})
export class FareOptimisationDifferencesService {

    public getTarificationDifference(differences: DifferenceType[], actualValue: string): IDifference {
        for (const difference of differences) {
            if (difference.rateArray?.length) {
                for (const rateDetail of difference.rateArray) {
                    if (rateDetail?.typeArray && rateDetail.scope === "Booking") {
                        const offerData: RateInDifferenceType = difference.rateArray.find((element: RateInDifferenceType): boolean => element.scope === "Offer");

                        const typeWithXRole: TypeForRateType = rateDetail?.typeArray?.find((type: TypeForRateType): boolean => !!type.xRole);
                        const typeWithXRoleFromOffer: TypeForRateInDifferenceType = offerData?.typeArray?.find((type: TypeForRateInDifferenceType): boolean => !!type.xRole);
                        if (typeWithXRole) {
                            return {
                                actualValue,
                                otherValue: typeWithXRole?.xRole,
                                impact: typeWithXRoleFromOffer && typeWithXRoleFromOffer.grade ? typeWithXRoleFromOffer.grade : "Change"
                            };
                        }
                    }
                }
            }
        }
    }

    public getValidityDifference(differences: DifferenceType[], actualValue: string): IDifference {
        for (const difference of differences) {
            if (difference.rateArray?.length) {
                for (const rateDetail of difference.rateArray) {
                    if (rateDetail.validity && rateDetail.scope === "Booking" && rateDetail.validity?.max?.value !== actualValue) {
                        const offerData: RateInDifferenceType = difference.rateArray.find((element: RateInDifferenceType): boolean => element.scope === "Offer");

                        return {
                            actualValue,
                            otherValue: rateDetail.validity?.max?.value,
                            impact: offerData && offerData.validity.grade ? offerData.validity.grade : "Change"
                        };
                    }
                }
            }
        }
    }

    public getLuggageDifference(differences: DifferenceType[], actualValue: string, wordingNotIncluded: string, wordingIncluded: string): IDifference {
        for (const difference of differences) {
            if (difference.rateArray?.length) {
                for (const rateDetail of difference.rateArray) {
                    if (rateDetail?.keywordArray && rateDetail.scope === "Offer") {
                        for (const keywordDetail of rateDetail?.keywordArray) {
                            if (keywordDetail.xCode && (keywordDetail.xCode === "LuggageInHold" || keywordDetail.xCode === "NoLuggageInHold")) {
                                return {
                                    actualValue,
                                    otherValue: actualValue === wordingIncluded ? wordingNotIncluded : wordingIncluded,
                                    impact: keywordDetail && keywordDetail.grade ? keywordDetail.grade : "Change"
                                };
                            }
                        }
                    }
                }
            }
        }
    }

    public getVendorDifference(differences: DifferenceType[], actualValue: string): IDifference {
        for (const difference of differences) {
            if (difference.rateArray?.length) {
                for (const rate of difference.rateArray) {
                    const bookingPriceVendor: string = rate.vendor?.name?.value ||
                        rate.vendor?.iata ||
                        rate.vendor?.code ||
                        rate.vendor?.carrierArray?.[0]?.iata;
                    if (rate.scope === "Booking" && bookingPriceVendor !== undefined && bookingPriceVendor !== actualValue) {
                        const offerData: RateInDifferenceType = difference.rateArray.find((element: RateInDifferenceType): boolean => element.scope === "Offer");

                        return {
                            actualValue,
                            otherValue: bookingPriceVendor,
                            impact: offerData && offerData.vendor.grade ? offerData.vendor.grade : "Change"
                        };
                    }
                }
            }
        }
    }
}
